import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { createPortal } from "react-dom";
import { GlobalContext } from "../../../Context/GlobalContext";
import useOrdersMain from "../../Services/OrdersMainServices/useOrdersMain";

const DeliveryServiceType = ({
  show,
  onClose,
  order,
  amount,
  Admin, 
  onSuccess,
}) => {
  const {changeCatalogOrderStatus}=useOrdersMain();

  const { api, adminId } = useContext(GlobalContext); 

  const [userID, setUserID] = useState(""); 
  const [paymentOrderId, setPaymentOrderId] = useState("");
  const [paymentmodelPaymentMode, setPaymentmodelPaymentMode] = useState("");
  const [paymentmodelCollectedBy, setPaymentmodelCollectedBy] =
    useState("Restaurant");
  const [paymentmodelRemarks, setPaymentmodelRemarks] = useState("");
  const [totalOrderAmount, setTotalOrderAmount] = useState("");

  const [apiResponse, setApiResponse] = useState(null);
  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    if (!order && amount == null) return;

    const finalAmount =
      amount ??
      order?.totalOrderPrice ??
      order?.pay_amount ??
      order?.order_amount ??
      order?.total_amount ??
      order?.net_amount ??
      "0";

    setUserID(order?.userid || order?.us_code || order?.fk_user_id || "");
    setPaymentOrderId(order?.orderid || order?.order_id || "");
    setTotalOrderAmount(finalAmount);
  }, [order, amount]);

  const resetPaymentmodelState = () => {
    setPaymentmodelPaymentMode("");
    setPaymentmodelCollectedBy("Restaurant");
    setPaymentmodelRemarks("");
    setApiResponse(null);
    setApiError(null);
  };

  const handleClose = () => {
    resetPaymentmodelState();
    onClose?.();
  };

 const handlePaymentmodelSubmit = async () => {
  if (!paymentmodelPaymentMode || !paymentmodelCollectedBy) {
    alert("Please fill in all required fields");
    return;
  }

  const payload = {
    adminId: adminId ? String(adminId) : undefined,
    userid: userID ? String(userID) : "",
    orderid: paymentOrderId,
    productid: "string",
    status: "cash_collected",
    time: new Date().toISOString(),
    payment: paymentmodelPaymentMode,
    paymentCollectedBy: paymentmodelCollectedBy,
    remarks: paymentmodelRemarks || paymentmodelCollectedBy,
    amount: Number(totalOrderAmount) || 0,
  };

  setApiError(null);
  setApiResponse(null);

  const result = await changeCatalogOrderStatus(payload);

  if (result.success) {
    toast.success(result.message);
    setApiResponse(result.data);
    resetPaymentmodelState();
    onSuccess?.();
    onClose?.();
  } else {
    setApiError(result);
    toast.error(result.message);
  }
};

  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
      <div className="bg-white w-full max-w-2xl rounded-xl shadow-lg overflow-hidden animate-fadeIn">
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-100">
          <h2 className="text-xl font-bold">Cash Collection</h2>
          <button
            className="text-gray-500 hover:text-black text-2xl"
            onClick={handleClose}
          >
            ×
          </button>
        </div>

        <div className="px-6 py-6">
          <div className="text-center mb-6">
            <h1 className="text-green-600 font-bold text-5xl">
              ₹{totalOrderAmount}
            </h1>
            <p className="text-gray-500 text-lg">Order Amount to Collect</p>
          </div>

          <hr className="mb-6" />

          {/* Payment Mode */}
          <div className="mb-6">
            <label className="text-lg font-semibold">Payment Mode</label>

            <div className="flex gap-3 flex-wrap mt-3">
              {[
                { label: "Cash", value: "cod" },
                { label: "Card Payment", value: "Card" },
              ].map(({ label, value }) => (
                <label
                  key={value}
                  className={`border px-6 py-3 rounded-lg text-lg cursor-pointer ${
                    paymentmodelPaymentMode === value
                      ? "bg-blue-600 text-white border-blue-700"
                      : "border-blue-500 text-blue-600"
                  }`}
                >
                  <input
                    type="radio"
                    name="paymentmodelPaymentMode"
                    value={value}
                    checked={paymentmodelPaymentMode === value}
                    onChange={(e) =>
                      setPaymentmodelPaymentMode(e.target.value)
                    }
                    className="hidden"
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>

          {/* Collected By */}
          <div className="mb-6">
            <label className="text-lg font-semibold">Collected By</label>

            <div className="flex gap-3 flex-wrap mt-3">
              {["Restaurant", "Delivery Partner"].map((option) => {
                const disabled = option === "Delivery Partner";

                return (
                  <label
                    key={option}
                    className={`px-6 py-3 border rounded-lg text-lg cursor-pointer ${
                      disabled
                        ? "opacity-50 cursor-not-allowed border-gray-400 text-gray-400"
                        : paymentmodelCollectedBy === option
                        ? "bg-blue-600 text-white border-blue-700"
                        : "border-blue-500 text-blue-600"
                    }`}
                    title={
                      disabled ? "Only Restaurant staff can collect cash" : ""
                    }
                  >
                    <input
                      type="radio"
                      name="paymentmodelCollectedBy"
                      value={option}
                      checked={paymentmodelCollectedBy === option}
                      onChange={(e) =>
                        !disabled && setPaymentmodelCollectedBy(e.target.value)
                      }
                      disabled={disabled}
                      className="hidden"
                    />
                    {option}
                  </label>
                );
              })}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t bg-gray-50">
          <button
            onClick={handleClose}
            className="border border-gray-500 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handlePaymentmodelSubmit}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg"
          >
            Confirm & Collect ₹{totalOrderAmount}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeliveryServiceType;
